var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slider',_vm._b({staticClass:"blw-slider blw-control",attrs:{"data-uid":_vm.uniqueId},on:{"input":_vm.onChange}},'v-slider',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }